module.exports = __webpack_public_path__ + "static/media/photo-9.b722f7aa.jpg";